import { useSelector } from 'react-redux';

import {
  selectEditQuestion,
  selectQuestion,
} from '~teacher/slices/quiz/quizSelectors';

import { ApplicationState } from '../../../../rootReducer';

/**
 * This utility method will select a question by it's id. If it is the question
 * being edited, it will use the staged editing question version
 * @param questionId
 */
export function useSelectQuestion({ questionId }: { questionId: string }) {
  const editingQuestion: ReturnType<typeof selectEditQuestion> =
    useSelector(selectEditQuestion);

  const currentQuestion: ReturnType<typeof selectQuestion> = useSelector(
    (state: ApplicationState) => {
      return state.teachers.quizData.questions[questionId];
    }
  );

  // need to handle both number and string
  if (editingQuestion?.questionId == questionId) {
    return { ...editingQuestion, isEditing: true };
  }

  return { ...currentQuestion, isEditing: false };
}
